module.exports = __webpack_public_path__ + "img/9788971849514.9ddd0f06.jpg";